import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

function Footer() {
  return (
    <footer className="custom-footer">
      <Container>
        <Row>
          <Col md={4}>
            <h5 className="footer-logo">Tathastu Education</h5>
            <p className="footer-description">
              Transforming school education through student counselling, digital branding, and academic mentorship. We’re on a mission to empower every school to unlock its full potential.
            </p>
          </Col>
          <Col md={4}>
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-links">
              <li><a href="/home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Our Services</a></li>
              {/* <li><a href="#challenges">School Challenges</a></li> */}
              <li><a href="#contact">Contact</a></li>
            </ul>
          </Col>
          <Col md={4}>
            <h6 className="footer-heading">Get in Touch</h6>
            <p className="footer-contact">📞 +91 9910292689</p>
            <p className="footer-contact">📧 info@tathastueducation.com</p>
            <p className="footer-contact">🌐 www.tathastueducation.com</p>
          </Col>
        </Row>
        <hr className="footer-line" />
        <p className="text-center footer-bottom">
          © {new Date().getFullYear()} Tathastu Education. Built for impact.
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
